import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";

import { fetchPageContent } from "../DownloadAndDelete/actions";
import { setA11yContent } from "../NavigationHelper/actions";
import { media } from "utils/style";
import { checkNestedObject } from "utils/checkNestedObject";

import FetchPageContent from "../../../hoc/FetchPageContent";

class CxPDownPage extends Component {
  state = {
    pageContent: ""
  };

  componentDidMount() {
    if (checkNestedObject(this.props.pageContent, "cxpdown", "richText")) {
      this.setState({ pageContent: this.props.pageContent.cxpdown.richText[0].description });
      this.props.setA11yContent("system error page", this.props.pageContent.cxpdown.sc_pagetitle);
    }
  }

  render() {
    return (
      <Container>
        <Header>{this.state.pageContent}</Header>
      </Container>
    );
  }
}

const mapStateToProps = ({ pageContent }) => ({
  pageContent
});

export default compose(
  connect(
    mapStateToProps,
    { fetchPageContent, setA11yContent }
  ),
  FetchPageContent
)(CxPDownPage);

const Container = styled.div`
  padding: 40px 20px 200px 20px;

  ${media.mobile`
    padding: 40px 16px;
  `}
`;

const Header = styled.h1`
  max-width: 785px;
  font-size: 18px;
  line-height: 20px;
`;
